import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import AnchorLink from "react-anchor-link-smooth-scroll";
import { useTranslation } from "react-i18next";
import Schedule from "./components/MainComponents/Schedule";
import TicketAvailability from "./components/MainComponents/TicketAvailability";
import SubmitProgramItem from "./components/MainComponents/SubmitProgramItem";
import generalInfoSchool from "../svg/generalInfoSchool.png";
import backgroundSchool from "../svg/backgroundSchool.png";
import lightbulb from "../svg/lightbulb.png";
import submitBackground from '../svg/submitBackground.png';
import LoadingDots from "./components/LoadingDots";

const HomePageSchool = () => {
  const [t, i18n] = useTranslation("global");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true); 
    emailjs
      .sendForm(
        "service_v8sqigr",
        "template_i8n2y0c",
        form.current,
        "kvvx_padstf0o02_b"
      )
      .then(
        (result) => {
          console.log(result.text);
          setLoading(false);
          setSubmitted(true);
        },
        (error) => {
          console.log(error.text);
          setLoading(false);
        }
      );
    e.target.reset();
  };

  return (
    <div className="App mx-auto pt-0">
      <div className="grid grid-cols-1 gap-4 justify-items-center pt-30">
        {/* Header */}
        <div className="relative w-full h-screen bg-cover bg-center" style={{ backgroundImage: `url(${backgroundSchool})`, zIndex:10 }}>
          <div className="absolute inset-0 bg-black/40 z-0"></div>
          <div className="relative z-10 flex flex-col justify-center items-center h-full">
            <div className="text-white text-center text-4xl sm:text-5xl md:text-6xl lg:text-8xl xl:text-9xl drop-shadow" style={{ fontFamily: "Bebas Neue" }}>
              {t("home.game-studios")}
            </div>
            <div style={{fontFamily:"Bebas Neue"}}  className="bg-[#6832c7] text-white uppercase text-sm sm:text-base md:text-lg lg:text-xl px-4 sm:px-6 py-2 rounded-2xl mt-4 w-11/12 sm:w-3/4 md:w-2/3 lg:w-3/5 text-center">
              {t("home.main-location")}
            </div>
            <div className="text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-8xl mt-4" style={{ fontFamily: "Bebas Neue" }}>
              27.02.2026 - 01.03.2026
            </div>
            <AnchorLink href="#moreInfo" className="mt-6">
              <button style={{fontFamily:"Bebas Neue"}} className="text-white uppercase text-sm sm:text-base md:text-lg lg:text-xl w-40 sm:w-44 md:w-48 h-12 sm:h-14 md:h-16 bg-[#6832c7] rounded-full border-2 border-[#6832c7]">
                {t("home.see-more")}
              </button>
            </AnchorLink>
          </div>
        </div>
        {/* Black line + General Information */}
        <section
          id="general"
          className="
            -mt-6 
            grid 
            grid-cols-1
            gap-4 
            items-center 
            relative 
            z-10 
            pt-12

            md:grid-cols-[45%_37.5%]
          "
        >
          <img
            src={generalInfoSchool}
            className="
              w-full
              justify-self-start
              pr-6
              md:pr-0
            "
            alt="logo"
          />
          <div className="pl-0 md:pl-24 md:pt-0 mr-6 ml-6 md:p-0">
            <div
              className="text-left text-5xl mb-2"
              style={{ fontFamily: "Bebas Neue", color: "#6832c7" }}
            >
              {t("home.general-information")}
            </div>

            <div
              className="text-base text-black"
              style={{
                fontFamily: "Poppins",
                textAlign: "justify",
                width: "100%",
                textAlignLast: "left",
              }}
            >
              {t("home.general-info-text-school")}
              <br /><br />
              {t("home.location")} {t("home.main-location")}
              <img
                src={lightbulb}
                alt="decorative"
                className="absolute -bottom-[10%] right-[15%] max-w-[40%] sm:max-w-[30%] md:max-w-[25%] lg:max-w-[20%] opacity-30 z-0"
                style={{ objectFit: "contain" }}
              />
            </div>

          </div>

          {/* Black line overlay */}
          <div className="absolute top-0 left-0 w-full h-px bg-white z-20" id="moreInfo"></div>
        </section>

        {/* Submit Program */}
        <section id="program" className="grid grid-cols-1 gap-4 justify-items-center pt-12" style={{ width:'95%', overflow:'visible'}}>
          <SubmitProgramItem page="school"/>
          <img
            src={submitBackground}
            alt="decorative"
            className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-50 z-0"
            style={{ width: '100%' }}
          />
        </section>
        <section id="tickets" className="grid grid-cols-1 gap-4 justify-items-center pt-12">
          <TicketAvailability page="school"/>
        </section>
        <section id="schedule" className="grid grid-cols-1 gap-4 justify-items-center pt-12" style={{maxWidth:'100%', width:'100%'}}>
          <Schedule page="school" language={i18n.language} />
        </section>
        <section className="grid grid-cols-1 gap-4 justify-items-center pt-12">
          <div
            style={{ fontFamily: "Bebas Neue" }}
            className="text-center text-5xl"
          >
            {t("home.what-to-expect-title")}
          </div>
          <div
            style={{ fontFamily: "Poppins", textAlignLast: "center" }}
            className="text-justify text-base lg:w-1/2 w-11/12 place-items-center text-align-last:center"
          >
            {t("home.what-to-expect-description")}
            <br />
            <br />
            <b>{t("home.what-to-expect-bold")}</b>
          </div>
          <div className="border-b-2 w-48 border-red-800 pt-10"></div>
        </section>

        {/* Contact Form */}
        <section className="grid lg:grid-cols-1 sm:grid-cols-1 gap-4 justify-items-center pt-12" id="contacts">
          <div className="grid grid-cols-1 justify-items-center">
            <div className="grid lg:grid-cols-1 w-full sm:grid-cols-1 gap-4 auto-cols-auto justify-items-center ">
              <div style={{ textAlign: "center" }}>
                <div
                  style={{ fontFamily: "Bebas Neue", color: '#6832c7', marginLeft:"auto", marginRight:"auto"}}
                  className="text-white px-2 text-center lg:text-center text-5xl justify-self-center lg:w-3/5"
                >
                  {t("home.contacts-form")}
                </div>
                <div
                  style={{ fontFamily: "Poppins", color: 'black' }}
                  className="px-2 text-white text-center lg:text-center text-base pt-2 lg:justify-self-center justify-self-center lg:w-2/5"
                >
                  {t("home.contact-form-text-school")}
                </div>
              </div>
            </div>
                <div className="grid lg:grid-cols-2 w-full sm:grid-cols-1 gap-4 auto-cols-auto justify-items-center">
                {loading ? (
                  <div className="lg:w-3/5 sm:w-11/12 w-11/12 pt-0 lg:justify-self-end flex justify-center items-center">
                    <LoadingDots page="school" />
                  </div>
                ) : !submitted ? (
              <form
                ref={form}
                onSubmit={sendEmail}
                className="lg:w-3/5 sm:w-11/12 w-11/12 pt-12 lg:justify-self-end"
              >
                <div className="relative z-0 w-full mb-3 group w-90%" style={{borderRadius:"50px", border:"1px solid #6832c7"}}>
                  <input
                    autoComplete="off"
                    type="text"
                    name="name"
                    id="name"
                    className="block pl-10 py-6 px-0 w-full text-base text-lime-300 bg-transparent appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                    placeholder=" "
                    style={{color:"#00ac9f"}}
                    required
                  />
                  <label
                    style={{ fontFamily: "Poppins", color:"#00ac9f" }}
                    className="peer-focus:font-medium absolute text-base text-white italic pl-8 dark:text-gray-400 duration-300 transform -translate-y-5 scale-75 top-5 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-lime-200 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-5"
                  >
                    {t("home.name-player")}
                  </label>
                </div>
                <div className="relative z-0 w-full mb-3 group" style={{borderRadius:"50px", border:"1px solid #6832c7"}}>
                  <input
                    autoComplete="off"
                    type="email"
                    name="email"
                    id="email"
                    className="block pl-8 py-6 px-0 w-full text-base text-lime-300 bg-transparent appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                    placeholder=" "
                    style={{color:"#00ac9f"}}
                    required
                  />
                  <label
                    style={{ fontFamily: "Poppins", color:"#00ac9f" }}
                    className="peer-focus:font-medium absolute text-base text-white italic pl-8  dark:text-gray-400 duration-300 transform -translate-y-5 scale-75 top-5 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-lime-200 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-5"
                  >
                    {t("home.e-mail-player")}
                  </label>
                </div>

                <div className="relative z-0 w-full mb-3 group" style={{borderRadius:"50px", border:"1px solid #6832c7"}}>
                  <textarea
                    maxLength="2000"
                    autoComplete="off"
                    type="text"
                    name="message"
                    id="message"
                    className="block resize-none pl-8 py-6 px-0 w-full h-64 mt-2 text-base text-lime-300 bg-transparent appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                    style={{color:"#00ac9f"}}
                    placeholder=" "
                    required
                  />
                  <label style={{fontFamily: "Poppins", color:"#00ac9f"}} className="peer-focus:font-medium absolute text-base text-white italic pl-10 dark:text-gray-400 duration-300 transform -translate-y-5 scale-75 top-5 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-lime-200 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-5">
                    {t("home.your-message-player")}
                  </label>
                </div>
                <div className="w-48 z-0 w-full mb-3">
                  <div className="py-1.5">
                    <div className={`text-center ${window.innerWidth < 640 ? 'mx-auto' : ''}`}>
                      <button
                        className="text-white w-48 h-20 text-center uppercase text-xl outline-pink-900"
                        style={{ height: "60px", backgroundColor:"#00ac9f", borderRadius:"50px", width:'100%'}}
                      >
                        {t("home.send")}
                      </button>
                    </div>  
                  </div>
                </div>
              </form> ) : (
                    <div className="w-full pt-0 lg:justify-self-end text-[#6832c7] text-3xl text-center pt-12" style={{ width:'60%', fontFamily:"Bebas Neue" }}>
                      {t("home.thank-you-contact")}
                    </div>
              )}
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2484.9916265955617!2d11.971946299999999!3d51.476668!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47a663daa70a6bf5%3A0x8d695ba67d78f1d7!2sHaus%2031%20-%20Institut%20f%C3%BCr%20Schulp%C3%A4dagogik%20und%20Grundschuldidaktik!5e0!3m2!1spt-PT!2spt!4v1772188550366!5m2!1spt-PT!2spt" 
                // width="410"
                height="494"
                loading="lazy"
                title="google maps"
                className="pt-12 lg:w-3/5 w-full justify-self-start lg:w-3/5"
              ></iframe>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default HomePageSchool;
